/**
 *  Эта пайпа умеет работать только с одним аргументом
 *  с неизменяющимся типом T
 */
export const pipe =
  <T>(...functions: ((arg: T) => T)[]) =>
  (firstArg: T) => {
    let currentResult = firstArg;

    for (const currentFuncion of functions) {
      currentResult = currentFuncion(currentResult);
    }

    return currentResult;
  };
